import type React from 'react';

import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeIcon from '../../components/NodeIcon';
import NodeHeader from '../NodeHeader';
import NodeWrapper from '../NodeWrapper';

/**
 * Renders a disconnected node component.
 *
 * @return {React.ReactElement} The JSX element representing the disconnected node component.
 */
export default function DisconnectNode(): React.ReactElement {
  const translate = useTranslate();

  return (
    <NodeWrapper condensed>
      <NodeHeader
        icon={<NodeIcon name='disconnect' title={translate('callflows.nodes.disconnect.name')} />}
        condensed
      />
      <Handle type='target' position={Position.Left} id='disconnect-target' />
    </NodeWrapper>
  );
}
